type FolderNode<T> = {folders: Map<string, FolderNode<T>>, items: T[]};

/**
 * Reorders items whose names are '/'-separated paths so that on every level
 * folders come before items. Otherwise keeps the input order (folders by first
 * occurrence), so the server-side collation is preserved.
 */
export const orderFoldersFirst = <T>(items: T[], getName: (item: T) => string): T[] => {
	const root: FolderNode<T> = {folders: new Map(), items: []};
	items.forEach(item => {
		const chunks = getName(item).split('/');
		chunks.pop();
		let node = root;
		chunks.forEach(dir => {
			if (!node.folders.has(dir)) node.folders.set(dir, {folders: new Map(), items: []});
			node = node.folders.get(dir);
		});
		node.items.push(item);
	});

	const result: T[] = [];
	const flatten = (node: FolderNode<T>) => {
		node.folders.forEach(flatten);
		result.push(...node.items);
	};
	flatten(root);
	return result;
};
